import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { InputComponentModule } from "@lantern/app/common/forms/input/input-component.module";
import { IconModule } from "@lantern/app/common/utils/icon/icon.module";
import { TooltipModule } from "@lantern/app/common/utils/tooltips/tooltip.module";
import { FormErrorsListComponentModule } from "../form-errors-list/form-errors-list-component.module";

import { FormFieldComponent } from "./form-field.component";

@NgModule({
  imports: [
    CommonModule,
    FormErrorsListComponentModule,
    InputComponentModule,
    IconModule,
    TooltipModule
  ],
  declarations: [FormFieldComponent],
  exports: [FormFieldComponent]
})
export class FormFieldComponentModule {}
